<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <div class="animate-spin w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-4"></div>
      <p class="text-gray-600 dark:text-gray-300">Loading wallpaper...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
// No props or logic needed for this simple component
</script>
